export function normalizeTimeOfDay(value) {
  if (!value) return null;

  const match = String(value).trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const seconds = match[3] === undefined ? 0 : Number(match[3]);

  if (hours > 23 || minutes > 59 || seconds > 59) return null;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function timeOfDayToSeconds(value) {
  const normalized = normalizeTimeOfDay(value);
  if (!normalized) return null;

  const [hours, minutes, seconds] = normalized.split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

export function getEarliestTimeOfDay(values = []) {
  return values
    .map((value) => ({
      value: normalizeTimeOfDay(value),
      seconds: timeOfDayToSeconds(value),
    }))
    .filter((item) => item.value && item.seconds !== null)
    .sort((left, right) => left.seconds - right.seconds)[0]?.value || null;
}

export function isActiveLine(line) {
  return line?.is_active !== false && line?.is_active !== 0 && String(line?.is_active) !== '0';
}

export function getLineEffectiveDismissalTime(line, defaultDismissalTime = null) {
  return normalizeTimeOfDay(line?.dismissal_time) || normalizeTimeOfDay(defaultDismissalTime);
}

export function getEarliestEffectiveDismissalTime({ school = null, lines = [] } = {}) {
  const defaultDismissalTime = normalizeTimeOfDay(school?.default_dismissal_time);
  const activeLines = (lines || []).filter(isActiveLine);

  if (activeLines.length === 0) {
    return defaultDismissalTime;
  }

  return getEarliestTimeOfDay(
    activeLines.map((line) => getLineEffectiveDismissalTime(line, defaultDismissalTime))
  );
}

export function formatTimeOfDay(value, locales = []) {
  const normalized = normalizeTimeOfDay(value);
  if (!normalized) return '';

  const [hours, minutes] = normalized.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date.toLocaleTimeString(locales, { hour: 'numeric', minute: '2-digit' });
}
